import { UpdateFloorPlanMemoTextParams, WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number, memoTextId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/texts/${memoTextId}/`;

export const updateFloorPlanMemoText = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
  memoTextId,
  content,
  position,
  style,
}: WithBranchParams<UpdateFloorPlanMemoTextParams>) => {
  const url = createApiUrl(branchUid, floorPlanId, memoTextId);
  const { data } = await axiosInstance.patch(url, {
    content,
    style: {
      color: style.color,
      width: style.width,
      opacity: style.opacity,
      font_size: style.fontSize,
      has_stroke: style.hasStroke,
      ...(style.rotation != null && { rotation: style.rotation }),
    },
    position,
    version: branchVersionId,
  });

  return data;
};
